import React from 'react';

const CampaignManagementConfig = {
	settings: {
		layout: {}
	},
	routes: [
		{
			path: '/template-messages/campaign-management',
			component: React.lazy(() => import('./CampaignManagement'))
		}
	]
};

export default CampaignManagementConfig;
